import {RouterModule, Routes} from "@angular/router";
import {
  FP_ROUTES, FS_ROUTES, HAS_GESTIONCOMMANDES,
  HAS_GESTION_FACTURATION_CLIENT,
  HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES,
  HAS_ROLE_FACTURE_EXTERNE,
  HAS_ROLE_AVOIR_EXTERNE
} from "../core/constants";
import {Auth2Guard} from "../core/services/security/auth2.guard";
import {NgModule} from "@angular/core";
import {FacturesFournisseursComponent} from "./fournisseurs/factures/factures-fournisseurs.component";
import {FacturesExternesComponent} from "./fournisseurs/factures-externes/factures-externes.component";
import {AvoirsExternesComponent} from "./fournisseurs/avoirs-externes/avoirs-externes.component";
import {FacturesRootComponent} from "./factures-root.component";
import {AvoirFournisseurComponent} from "./fournisseurs/avoirs/avoir-fournisseur.component";
import {PointFacturationComponent} from "./clients/points-facturation/point-facturation.component";
import {FacturesClientsComponent} from "./clients/factures/factures-clients.component";
import {TableauDeBordComponent} from "./clients/tableau-de-bord/tableau-de-bord.component";
import {FamilleFacturationComponent} from "./clients/famille-facturations/famille-facturation.component";
import {FacturationClientPanelComponent} from "./clients/parametrage/facturation-client-panel/facturation-client-panel.component";
import {ElementFacturableComponent} from "./clients/elements-facturables/element-facturable.component";
import {FraisFixeComponent} from "./clients/frais-fixes/frais-fixe.component";

const routes: Routes = [
  {
    path: FP_ROUTES.FACTURES,
    component: FacturesRootComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    data: {
      roles: [HAS_GESTION_FACTURATION_CLIENT, HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES, HAS_ROLE_FACTURE_EXTERNE, HAS_ROLE_AVOIR_EXTERNE],
      permission: 'OR'
    } /* || HAS_ROLE_PLC_FACTURES */,
    children: [
      {
        path: FS_ROUTES.ELEMENT_FACTURABLE,
        component: ElementFacturableComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.FRAIS_FIXE,
        component: FraisFixeComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.FAMILLE_FACTURATION,
        component: FamilleFacturationComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.POINT_FACTURATION,
        component: PointFacturationComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.FACTURATION_CLIENT_PARAMETRAGE,
        component: FacturationClientPanelComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.FACTURES_CLIENTS,
        component: FacturesClientsComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.TABLEAU_DE_BORD,
        component: TableauDeBordComponent,
        runGuardsAndResolvers: 'always',
        data: { roles: [HAS_GESTION_FACTURATION_CLIENT] }
      },
      {
        path: FS_ROUTES.FACTURES_FOURNISSEURS,
        component: FacturesFournisseursComponent,
        runGuardsAndResolvers: 'always',
        data: {
          roles: [HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES]
        }
      },
      {
        path: `${FS_ROUTES.FACTURES_FOURNISSEURS}/:factureId`,
        component: FacturesFournisseursComponent,
        runGuardsAndResolvers: 'always',
        data: {
          roles: [HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES]
        }
      },
      {
        path: FS_ROUTES.AVOIRS,
        component: AvoirFournisseurComponent,
        runGuardsAndResolvers: 'always',
        data: {
          roles: [HAS_ROLE_COMMANDES_FOURNISSEURS_FACTURES]
        }
      },
      {
        path: FS_ROUTES.FACTURES_EXTERNES,
        component: FacturesExternesComponent,
        runGuardsAndResolvers: 'always',
        data: {
          roles: [HAS_ROLE_FACTURE_EXTERNE]
        }
      },
      {
        path: FS_ROUTES.AVOIRS_EXTERNES,
        component: AvoirsExternesComponent,
        runGuardsAndResolvers: 'always',
        data: {
          roles: [HAS_ROLE_AVOIR_EXTERNE]
        }
      }
    ]
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacturesRoutingModule {
}
